import axios from 'axios';

export function readBackendErrorCode(caughtError: unknown): string {
  if (axios.isAxiosError(caughtError) === false || caughtError.response === undefined) {
    return '';
  }
  const responseData = caughtError.response.data;
  if (responseData === null || typeof responseData !== 'object') {
    return '';
  }
  const candidateCode = (responseData as Record<string, unknown>).error_code;
  return typeof candidateCode === 'string' ? candidateCode : '';
}
